import type { PmNodeConverter, PmNodeJson } from './../pm-converters/types';
import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from './../ricos-content';
import type { ButtonData } from './../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { ButtonNode } from './../ricos-types';

const toTiptapButtonConvert = (node: ButtonNode): PmNodeJson => ({
  type: node.buttonData.type === 'LINK' ? TIPTAP_LINK_BUTTON_TYPE : TIPTAP_ACTION_BUTTON_TYPE,
  attrs: {
    ...node.buttonData,
    id: node.id,
  },
});

const fromTiptapButtonConvert = (node: PmNodeJson): ButtonNode => {
  const { id, ...data } = node.attrs || {};
  return {
    type: Node_Type.BUTTON,
    id,
    nodes: [],
    buttonData: {
      ...(data as ButtonData),
    },
  };
};

export const linkButtonConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.BUTTON],
    // @ts-ignore $TSFixMe
    convert: toTiptapButtonConvert,
  },
  fromPm: {
    types: [TIPTAP_LINK_BUTTON_TYPE],
    convert: fromTiptapButtonConvert,
  },
};

export const actionButtonConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.BUTTON],
    // @ts-ignore $TSFixMe
    convert: toTiptapButtonConvert,
  },
  fromPm: {
    types: [TIPTAP_ACTION_BUTTON_TYPE],
    convert: fromTiptapButtonConvert,
  },
};
